module.exports = __webpack_public_path__ + "img/1.4c8d1fdf.png";